import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IEventDto, IFilterPaginationDto, IRestaurantDto } from '../models';

@Injectable()
export class EventService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getEventList(id: number): Observable<IEventDto[]> {
    return this.get(`event/${id}`);
  }
}
